import React, { useEffect, useState } from 'react';
import Header from "../../../../components/Headers/BasicHeader";
import '../Index.css'
import Paginations from '../../../../components/Pagination/BasicPagination';
import { useNavigate } from "react-router-dom";
import { setDataOnGrid, applySearch } from '../../../../utils/views/pages/Dynamics'

import {
    Card,
    CardHeader,
    Container,
    Row,
    Col,
    Table,
    Form,
    FormGroup,
    InputGroupAddon,
    InputGroupText,
    Input,
    InputGroup,
    Button,
    Spinner
} from "reactstrap";
import { getPayments, deletePayment, getCredentials } from "../../../../network/ApiAxios";
import { format } from 'date-fns';
import { periodLabels } from '../../../../utils/views/pages/StaticPatterns'

const Payments = () => {

    const [payments, setPayments] = useState([]);
    const [paymentsBackup, setPaymentsBackup] = useState([]);
    const [reloadData, setReloadData] = useState(false)
    const [itemsPerPage, setItemsPerPage] = useState(process.env.REACT_APP_PAGE_ITEMS)
    const [currentPage, setCurrentPage] = useState(1)
    const [searchKey, setSearchKey] = useState('')
    const [foundRegisters, setFoundRegisters] = useState()
    const navigate = useNavigate();
    const searchFields = ['date']
    const [sortField, setSortField] = useState('')
    const [sortDirection, setSortDirection] = useState('asc')
    const [loadingId, setLoadingId] = useState('')
    const [isLoading, setisLoading] = useState(false)
    const [buyers, setBuyers] = useState({})
    const [searchAction, setSearchAction] = useState(false)

    /**
     * Carregamento dos dados principais para alimentar o grid 
     * Alimenta os objetos que permitirão realizar buscas e filtragens
     * dinamicamente
     */
    useEffect(() => {
        const runAsync = async () => {
            setisLoading(true);

            let params = { filter: {} }

            const response = await getPayments(params);
            const { data } = response;

            if (data.success) {
                setFoundRegisters(data.payments?.length)
                const sortedData = applySorting(data.payments);
                setDataOnGrid(sortedData, setPayments, currentPage, itemsPerPage);
                setPaymentsBackup(data.payments);
                setReloadData(false);
                setLoadingId('');
                setisLoading(false);
            }
        }
        runAsync();

    }, [reloadData]);

    /**
     * Gatilho para carregar dados PHI de forma assíncrona sem
     * fazer o usuário ficar esperando demais para ver
     * os registros principais do GRID
     * 
     */
    useEffect(() => {
        const runAsync = async () => {
            let _buyers = {}

            for (let i = 0; i < payments.length; i++) {
                let params = {
                    filter: {
                    },
                    constraint: {
                        user: { account: payments[i].account },
                        type: { isOwner: true }
                    }
                }
                let { data } = await getCredentials(params)
                if (data.success) {
                    _buyers[payments[i]._id] = data.credentials[0]?.user
                }
            }
            setBuyers(_buyers)
        }
        runAsync();

    }, [payments])


    /**
     * Gatilho que captura situações onde devemos realizar busca de dados de acordo com 
     * filtro e reordenar os dados para mostrar no grid
     */
    useEffect(() => {
        if(!searchAction){
            applySearch(searchKey, searchFields, setPayments, paymentsBackup, setFoundRegisters, currentPage, itemsPerPage, true);
            const sortedData = applySorting(paymentsBackup);
            setDataOnGrid(sortedData, setPayments, currentPage, itemsPerPage);
        } else {
            setSearchAction(false)
        }

    }, [sortField, sortDirection, searchKey, currentPage, itemsPerPage])

    const sortData = (data, field, direction) => {
        if (!field) return data;


        const getNestedValue = (obj, path) => {
            return path.split('.').reduce((acc, part) => acc && acc[part], obj);
        }


        return [...data].sort((a, b) => {
            let aValue = getNestedValue(a, field) || '';
            let bValue = getNestedValue(b, field) || '';
            if (typeof aValue === 'string') aValue = aValue.toLowerCase();
            if (typeof bValue === 'string') bValue = bValue.toLowerCase();

            if (direction === 'asc') {
                //Para ordem crescrente
                return aValue > bValue ? 1 : -1;
            } else {
                //Para ordem decrescente
                return aValue < bValue ? 1 : -1;
            }
        })

    }

    const applySorting = (data) => {
        if (!sortField) return data;
        return sortData(data, sortField, sortDirection);
    }

    let handleSort = (field) => {
        if (sortField === field) {
            setSortDirection(sortDirection === 'asc' ? 'desc' : 'asc');
        } else {
            setSortField(field);
            setSortDirection('asc');
        }
        setCurrentPage(1);
    }



    let handleSearch = (e) => {
        setSearchAction(true)
        setSearchKey(e.target.value)
        applySearch(e.target.value, searchFields, setPayments, paymentsBackup, setFoundRegisters, currentPage, itemsPerPage, true);
    }

    return (
        <>
            <Header></Header>

            <Container>
                <Row>
                    <div className="col">
                        <Card className="shadow">
                            <CardHeader className="border-0 pb-3 pt-3 pt-md-3">
                                <div className="header bg-lightgray pb-3 pt-3 pt-md-1">
                                    <Container fluid>
                                        <div className="header-body">
                                            <Form className="navbar-search-light form-inline mr-3 d-none d-md-flex  w-100   ">
                                                <FormGroup className="mb-0 w-100 ">
                                                    <InputGroup id="search-input" className="input-group-alternative w-100 ">

                                                        <InputGroupAddon addonType="prepend" className='w-100'>
                                                            <InputGroupText >
                                                                <i className="fas fa-search" />
                                                            </InputGroupText>
                                                            <Input value={searchKey} onChange={handleSearch} className='w-100' placeholder="Search" type="text" />
                                                        </InputGroupAddon>

                                                    </InputGroup>
                                                </FormGroup>
                                            </Form>
                                        </div>
                                    </Container>
                                </div>

                            </CardHeader>


                            {isLoading && !loadingId ? (
                                <div className="text-center p-5">
                                    <Spinner size="lg" />
                                </div>

                            ) : (
                                <Table className="align-items-center table-flush" responsive>
                                    <thead>
                                        <tr>
                                            <th scope="col">
                                                Buyer
                                            </th>
                                            <th scope="col"
                                                onClick={() => handleSort('subscription.plan.app.name')}
                                                style={{ cursor: 'pointer', userSelect: 'none' }}
                                                className={sortField === 'subscription.plan.app.name' ? 'table-header-sorted' : ''}
                                            >
                                                App

                                                <i className={`fas fa-arrow-${sortDirection === 'asc' ? 'down' : 'up'} ml-2`} />

                                            </th>

                                            <th scope="col"
                                                onClick={() => handleSort('subscription.plan.name')}
                                                style={{ cursor: 'pointer', userSelect: 'none' }}
                                                className={sortField === 'subscription.plan.name' ? 'table-header-sorted' : ''}
                                            >
                                                Plan

                                                <i className={`fas fa-arrow-${sortDirection === 'asc' ? 'down' : 'up'} ml-2`} />

                                            </th>

                                            <th scope="col"
                                                onClick={() => handleSort('subscription.licensesLimit')}
                                                style={{ cursor: 'pointer', userSelect: 'none' }}
                                                className={sortField === 'subscription.licensesLimit' ? 'table-header-sorted' : ''}
                                            >
                                                Licenses

                                                <i className={`fas fa-arrow-${sortDirection === 'asc' ? 'down' : 'up'} ml-2`} />

                                            </th>

                                            {/* Adicionei ordenação para as colunas restantes também */}
                                            <th scope="col"
                                                onClick={() => handleSort('subscription.plan.periodicity')}
                                                style={{ cursor: 'pointer', userSelect: 'none' }}
                                                className={sortField === 'subscription.plan.periodicity' ? 'table-header-sorted' : ''}
                                            >
                                                Periodicity

                                                <i className={`fas fa-arrow-${sortDirection === 'asc' ? 'down' : 'up'} ml-2`} />

                                            </th>

                                            <th scope="col"
                                                onClick={() => handleSort('date')}
                                                style={{ cursor: 'pointer', userSelect: 'none' }}
                                                className={sortField === 'date' ? 'table-header-sorted' : ''}
                                            >
                                                Date

                                                <i className={`fas fa-arrow-${sortDirection === 'asc' ? 'down' : 'up'} ml-2`} />

                                            </th>

                                            <th scope="col"
                                                onClick={() => handleSort('total')}
                                                style={{ cursor: 'pointer', userSelect: 'none' }}
                                                className={sortField === 'total' ? 'table-header-sorted' : ''}
                                            >
                                                Total

                                                <i className={`fas fa-arrow-${sortDirection === 'asc' ? 'down' : 'up'} ml-2`} />

                                            </th>

                                            <th scope="col" className='text-right'>Actions</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {payments.map(payment => (
                                            <tr key={payment._id}>
                                                <td scope="row">
                                                    {
                                                        buyers[payment._id]?.name ?
                                                            buyers[payment._id]?.name :
                                                            <div className="text-center p-1">
                                                                <Spinner size="lg" />
                                                            </div>
                                                    }
                                                </td>
                                                <td>{payment.subscription.plan.app.name} </td>
                                                <td>{payment.subscription.plan.name}</td>
                                                <td>{payment.subscription.licensesLimit}</td>
                                                <td>{periodLabels[payment.subscription.plan.periodicity]}</td>
                                                <td>{format(payment.date, "yyyy-MM-dd")}</td>
                                                <td> $ {payment.total.toFixed(2)}</td>
                                                <td className='text-right'>
                                                    <Button className="btn-icon action" color="success" type="button"
                                                        onClick={() => navigate('/admin/payment/view/' + payment._id)}
                                                    >

                                                        <span className="btn-inner--icon">
                                                            <img
                                                                id="view-button"
                                                                alt="view"
                                                                src={require("assets/img/icons/common/eye-button.svg").default}
                                                            />
                                                        </span>

                                                    </Button>


                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </Table>
                            )}
                        </Card>
                    </div>
                </Row>

                <Row className='pt-md-3'>
                    <Col>
                        <span className="h5 itens-quantity">
                            {paymentsBackup?.length} payments
                        </span>
                    </Col>
                    <Col>
                        <Paginations
                            itemsPerPage={itemsPerPage}
                            totalItems={foundRegisters}
                            setCurrentPage={setCurrentPage}
                            currentPage={currentPage}
                        />

                    </Col>
                </Row>

            </Container>

        </>
    );
}

export default Payments;
